import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Loader2, Share2 } from "lucide-react";

const isMobile = () => /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) || (navigator.maxTouchPoints > 1 && /Macintosh/.test(navigator.userAgent));

// Pré-carrega o PDF para o menu de compartilhar abrir no mesmo toque (exigência do Safari).
export function SharePdfButton({ order, kind = "budget", testid = "share-budget-pdf-btn" }) {
  const [blob, setBlob] = useState(null);
  const [busy, setBusy] = useState(false);
  const fname = `OS-${order.order_number ?? order.id.slice(-6)}-${(order.vehicle?.plate || "OS").replace(/\//g, "-")}-${kind === "budget" ? "orcamento" : "os-completa"}.pdf`;
  const load = async () => (await api.get(`/orders/${order.id}/pdf/${kind}`, { responseType: "blob" })).data;
  useEffect(() => {
    let off = false;
    setBlob(null);
    load().then((b) => { if (!off) setBlob(b); }).catch(() => {});
    return () => { off = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [order.id, order.updated_at, order.budget?.total, kind]);
  const download = (b) => {
    const url = URL.createObjectURL(b);
    const a = document.createElement("a");
    a.href = url; a.download = fname; document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  };
  const onClick = async () => {
    let b = blob;
    if (!b) {
      setBusy(true);
      try { b = await load(); setBlob(b); } catch (e) { toast.error(formatApiError(e)); return; } finally { setBusy(false); }
      if (isMobile()) { toast.info("PDF pronto. Toque de novo em Compartilhar PDF."); return; }
    }
    if (isMobile()) {
      const file = new File([b], fname, { type: "application/pdf" });
      if (navigator.canShare?.({ files: [file] })) {
        try { await navigator.share({ files: [file], title: fname }); } catch (e) { if (e?.name !== "AbortError") toast.error("Não foi possível compartilhar"); }
        return;
      }
    }
    download(b);
  };
  return (
    <Button type="button" data-testid={testid} onClick={onClick} disabled={busy} title="Enviar o arquivo PDF (no computador, baixa o PDF)"
      className="h-10 px-4 bg-sky-600 hover:bg-sky-500 text-white text-sm font-bold uppercase tracking-wide">
      {busy ? <Loader2 className="h-4 w-4 mr-1.5 animate-spin" /> : <Share2 className="h-4 w-4 mr-1.5" />} Compartilhar PDF
    </Button>
  );
}
